import React, { Fragment } from "react"
import MaterialTable from "material-table"
import ParentRoleDiloag from "../parentRoleDialog"
import { isEmpty } from "lodash"
import { Typography, Hidden } from "@material-ui/core"

class ParentTable extends React.Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    const {
      roles,
      classes,
      apiData,
      filteredRoles,
      dialogOpen,
      editRole,
    } = this.props
    return (
      <Fragment>
        <div className={classes.resultsWrapper}>
          {!isEmpty(roles) && (
            <Typography variant="h6" className={classes.resultsNumber}>
              {apiData.parents.length} Parent Roles
            </Typography>
          )}
        </div>

        {/* WEB VIEW */}
        <Hidden smDown>
          <MaterialTable
            title="Parent Roles"
            data={filteredRoles.map(x => {
              if (!x.tableData) {
                x.tableData = {}
              }
              return x
            })}
            columns={[
              { title: "Name", field: "name" },
              { title: "Type", field: "type" },
              { title: "Child Count", field: "child_roles" },
              { title: "Shoot Uses", field: "shoot_uses" },
              { title: "Crew Uses", field: "crew_uses" },
            ]}
            parentChildData={(row, rows) =>
              rows.find(a => a.id === row.parent_role_id)
            }
            options={{
              actionsColumnIndex: -1,
              search: false,
              showTitle: false,
              toolbar: false,
            }}
            actions={[
              rowData => ({
                icon: "edit",
                tooltip: "Edit Parent Role",
                onClick: (_e, rowData) => {
                  this.props.setDialogOpen(true)
                  this.props.setEditRole(rowData)
                },
                hidden: rowData.type === "child",
              }),
            ]}
            editable={{
              onRowDelete: oldData => {
                return new Promise((resolve, reject) => {
                  this.props
                    .deleteParent(oldData.id)
                    .then(resolve)
                    .catch(reject)
                })
              },
              isDeletable: r => r.type === "parent",
            }}
            isLoading={isEmpty(filteredRoles) ? true : false}
            style={{ borderRadius: "10px" }}
          />
        </Hidden>

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <MaterialTable
            title="Parent Roles"
            data={filteredRoles.map(x => {
              if (!x.tableData) {
                x.tableData = {}
              }
              return x
            })}
            columns={[
              { title: "Name", field: "name" },
              { title: "Child Count", field: "child_roles" },
            ]}
            parentChildData={(row, rows) =>
              rows.find(a => a.id === row.parent_role_id)
            }
            options={{
              actionsColumnIndex: -1,
              search: false,
              showTitle: false,
              toolbar: false,
            }}
            actions={[
              rowData => ({
                icon: "edit",
                tooltip: "Edit Parent Role",
                onClick: (_e, rowData) => {
                  this.props.setDialogOpen(true)
                  this.props.setEditRole(rowData)
                },
                hidden: rowData.type === "child",
              }),
            ]}
            editable={{
              onRowDelete: oldData => {
                return new Promise((resolve, reject) => {
                  this.props
                    .deleteParent(oldData.id)
                    .then(resolve)
                    .catch(reject)
                })
              },
              isDeletable: r => r.type === "parent",
            }}
            isLoading={isEmpty(filteredRoles) ? true : false}
            style={{ borderRadius: "10px" }}
          />
        </Hidden>

        <ParentRoleDiloag
          open={dialogOpen}
          currentRole={editRole}
          apiData={apiData}
          onClose={bool => {
            if (bool) {
              this.props.loadData()
            }
            this.props.setEditRole(null)
            this.props.setDialogOpen(false)
          }}
        />
      </Fragment>
    )
  }
}

export default ParentTable
